import {ExpectedTurnoverComponent} from './expected.turnover.component';

export * from './expected.turnover.component'

export const EXPECTED_TURNOVER_COMPONENTS = [
    ExpectedTurnoverComponent
];



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/components/expected.turnover/index.ts